import { ICategory, Room } from "@eventr/common";
import { Icon, TEventrIcons } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import i18n from "i18n/i18next";
import { useMemo } from "react";
import { getCategoryColours } from "utils";
import useDerivedScreenType from "v2/hooks/useDerivedScreenType";
import { useFormatValue } from "../../hooks/useFormatValue";
import { isSameDay } from "../card-utils";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "../subComponents/cardText";
import { ColouredIcon } from "../subComponents/colouredIcon";
import { DisplayLabel } from "../subComponents/displayLabel";
interface HotelHeaderProps {
  category?: ICategory | undefined;
  name: string;
  label: string;
  room?: Room;
  labelTime?: string;
  visibility?: string;
  date?: string;
  rooms?: Room[];
}

export const HotelHeader = ({ category, name, label, room, labelTime, visibility, date, rooms }: HotelHeaderProps) => {
  const { past } = useObjectContext();
  const screenType = useDerivedScreenType();
  const { formatValue } = useFormatValue();

  const labelOverride = useMemo(() => {
    if (!date || !rooms?.length) return;

    const matchingCheckIn = rooms.find((r) => r.checkIn && isSameDay(date, r.checkIn));
    if (matchingCheckIn?.checkIn) {
      return `${i18n.t("cards.check-in")} ${formatValue(matchingCheckIn.checkIn, "time")}`;
    }

    const matchingCheckOut = rooms.find((r) => r.checkOut && isSameDay(date, r.checkOut));
    if (matchingCheckOut?.checkOut) {
      return `${i18n.t("cards.check-out")} ${formatValue(matchingCheckOut.checkOut, "time")}`;
    }
  }, [date, rooms, formatValue]);

  const iconColour = getCategoryColours(past, category);

  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Stack direction="row" sx={{
        gap: "8px"
      }}>
        <Icon name={(category?.icon as TEventrIcons) ?? "Stays"} iconColour={iconColour} />
        <CardText variant="bodyBold">{name}</CardText>
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "8px"
        }}>
        {visibility?.toLowerCase() === "private" ? (
          <ColouredIcon height="16px" name="Private" />
        ) : (
          visibility?.toLowerCase() === "public" && <ColouredIcon height="16px" name="Public" />
        )}
        {!["upNext", "team", "edit"].includes(screenType) && (
          <CardText variant="bodyBold">{room?.checkIn ? formatValue(room.checkIn, "date") : ""}</CardText>
        )}
        {(screenType === "upNext" || screenType === "team") && (
          <DisplayLabel
            label={label}
            overrideLabel={screenType === "team" ? labelOverride : undefined}
            labelTime={labelTime}
          />
        )}
      </Stack>
    </Stack>
  );
};
